import defaultThumbnail from "src/assets/images/default_event_thumbnail.jpg";
import defaultIcon from "src/assets/icon/default_user_icon.svg";

type ImageType = "thumbnail" | "icon";

const imageLoadErrorHandler = (
    e: React.SyntheticEvent<HTMLImageElement, Event>,
    imageType: ImageType
) => {
    const target = e.target as HTMLImageElement;

    switch (imageType) {
        case "thumbnail":
            target.src = defaultThumbnail;
            break;
        case "icon":
            target.src = defaultIcon;
            break;
        default:
            break;
    }
};

export default imageLoadErrorHandler;
